import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import Api from "../../../../../Services/Api";
import {ACTIVITY_TYPE, HttpStatus, ReportType} from "../../../../common/Constants";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import {leasingPaymentStatus, TabLabels} from "../config";
import DataCustomerOwnerTab from "./dataCustomerOwnerTab";
import DataPenagihanTab from "./dataPenagihanTab";
import DataUnitTab from "./dataUnitTab";
import M from "moment/moment";
import {contructQueryParam, fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";
import {service} from "../service";
import * as R from "ramda";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import ListBbm from "./listBbm";
import {downloadPdf, printPDF} from "./downloadUtils";
import DetailPenagihanLeasingPrintPreview from "./detailPenagihanLeasingPrintPreview";
import moment from "moment/moment";

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            activeTabIndex: 0,
            errors: {},
            signByOptions: [],
            rawSignByOptions: [],
            customer: {
                cityOptions: null,
                provinceOptions: null,
                kecamatanOptions: null,
                kelurahanOptions: null,
            },
            owner: {
                cityOptions: null,
                provinceOptions: null,
                kecamatanOptions: null,
                kelurahanOptions: null,
            },
            signedBy: null,
            notEquals: false,
            data: {
                dataCetakan: [],
            },
            cancelAlert: false,
            openBBM: false,
            jpTac: null,
            dataPreviewPdf: null,
            printPreviewVisible: false,
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailLeasing,
            menuName: "Penagihan Leasing - Detail",
            setError: this.props.setError,
            args: this.props.detail.id,
        });
        if (response.ok && response.data.status === HttpStatus.FAILED) {
            this.props.onClickClose(null);
        }
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            if (response.data.data?.dataCetakan?.length === 0) {
                response.data.data.dataCetakan = [{}, {}, {}];
            }
            const dataCustomer = response.data.data?.dataCustomer;
            const dataPemilik = response.data.data?.dataPemilik;
            const responses = await Promise.all([
                ...this.callOptionApis(
                    dataCustomer?.idKabkot,
                    dataCustomer?.idProvinsi,
                    dataCustomer?.idKecamatan,
                    dataCustomer?.idKelurahan
                ),
                ...this.callOptionApis(
                    dataPemilik?.idKabkot,
                    dataPemilik?.idProvinsi,
                    dataPemilik?.idKecamatan,
                    dataPemilik?.idKelurahan
                ),
            ]);
            this.mapResponses(responses.slice(0, 4), "customer");
            this.mapResponses(responses.slice(4, 8), "owner");

            await this.setState((prevValue) => ({
                ...prevValue,
                data: response.data.data || null,
            }));
        }
        await this.fetchSignedBy();
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    fetchSignedBy = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getEmployeeForDDLLeasingPayment,
            menuName: "Penagihan Leasing - Detail",
            setError: this.props.setError,
            args: contructQueryParam({
                marketingLine: 6, administrationLine: 6,
            })
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let signedBy = this.state.data.dataCetakan?.[0]?.signedBy;
            let {data} = res.data;
            if (!R.isNil(signedBy)) signedBy = data.find(item => item.userId === signedBy);
            this.setState((prevValue) => ({
                ...prevValue,
                signedBy: R.isNil(signedBy) ? null : mapToObjectDDL(signedBy.name, signedBy.userId),
                signByOptions: data.map(item => mapToObjectDDL(item.name, item.userId)),
                rawSignByOptions: data,
            }));
        }
    };

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        let currDataPenagihan = this.state.data?.dataPenagihan;
        let prevDataPenagihan = prevState.data?.dataPenagihan;
        if (currDataPenagihan?.jpTac1Amount !== prevDataPenagihan?.jpTac1Amount ||
            currDataPenagihan?.jpTac2Amount !== prevDataPenagihan?.jpTac2Amount ||
            currDataPenagihan?.jpTac3Amount !== prevDataPenagihan?.jpTac3Amount) {
            let total = parseInt(currDataPenagihan?.jpTac1Amount || 0)
                + parseInt(currDataPenagihan?.jpTac2Amount || 0)
                + parseInt(currDataPenagihan?.jpTac3Amount || 0);
            let notEquals = total !== currDataPenagihan?.jumlahJptac;
            this.setState((prevValue) => ({...prevValue, notEquals}));
        }
    }

    handleChangePenagihanValue = (name, value) => {
        if (this.state.data?.dataPenagihan) {
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    dataPenagihan: {
                        ...prevValue.data.dataPenagihan,
                        [name]: value,
                    },
                },
            }));
        }
    };

    handleOpenBBM = (bbm) => {
        this.setState((prevValue) => ({
            ...prevValue,
            openBBM: !prevValue.openBBM,
            jpTac: bbm,
        }));
    };

    handleSubmitBBM = (noBBM) => {
        let {jpTac} = this.state;
        this.handleChangePenagihanValue(jpTac, noBBM);
        this.handleOpenBBM(null);
    };

    constructDataRequest = (type) => {
        let {tab} = this.props;
        const data = this.state.data;
        const dataPenagihan = data?.dataPenagihan;
        const dataUnit = data?.dataUnit;
        const dataCustomer = data?.dataCustomer;
        const dataOwner = data?.dataPemilik;
        let status = type === "cancel"
            ? leasingPaymentStatus.BATAL
            : type === "save"
                ? tab
                : type === "process" && tab === leasingPaymentStatus.BELUM_PENAGIHAN
                    ? leasingPaymentStatus.SUDAH_PENAGIHAN
                    : leasingPaymentStatus.PELUNASAN;
        return ({
            leasingPaymentId: data.leasingPaymentId,
            kodeCabang: this.props.kodeCabang,
            orderH1: data?.nomorFakturJual,
            leasingId: data?.dataLeasing?.leasingId,
            noPoLeasing: data?.noPoLeasing,
            leasingOtherPayment: dataPenagihan?.leasingOtherPayment,
            customerId: dataCustomer?.customerId,
            customerOwnerId: dataOwner?.customerOwnerId,
            frameNumber: dataUnit?.frameNumber,
            engineNumber: dataUnit?.engineNumber,
            jpTac1Bbm: dataPenagihan?.jpTac1Bbm,
            jpTac1Amount: dataPenagihan?.jpTac1Amount ? parseFloat(dataPenagihan?.jpTac1Amount) : null,
            jpTac2Amount: dataPenagihan?.jpTac2Amount ? parseFloat(dataPenagihan?.jpTac2Amount) : null,
            jpTac3Amount: dataPenagihan?.jpTac3Amount ? parseFloat(dataPenagihan?.jpTac3Amount) : null,
            jpTac1TransferredAmount: dataPenagihan?.jpTac1TransferredAmount ? parseFloat(dataPenagihan?.jpTac1TransferredAmount) : null,
            jpTac2TransferredAmount: dataPenagihan?.jpTac2TransferredAmount ? parseFloat(dataPenagihan?.jpTac2TransferredAmount) : null,
            jpTac3TransferredAmount: dataPenagihan?.jpTac3TransferredAmount ? parseFloat(dataPenagihan?.jpTac3TransferredAmount) : null,
            leasingOtherTransferredPayment: dataPenagihan?.leasingOtherTransferredPayment ? parseFloat(dataPenagihan?.leasingOtherTransferredPayment) : null,
            jpTac2Bbm: dataPenagihan?.jpTac2Bbm,
            jpTac3Bbm: dataPenagihan?.jpTac3Bbm,
            leasingOtherTransferredBbm: dataPenagihan?.leasingOtherTransferredBbm,
            leasingPaymentStatus: status,
            nomorIndent: data?.nomorIndent,
            nomorProspek: data?.nomorProspek,
            bastFotoSmhBase64: dataPenagihan?.fotoBastSmhBase64,
            dataCetakan: service.constructDataCetakan(data?.dataCetakan),
        });
    };

    handleSave = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let {tab} = this.props;
        const request = this.constructDataRequest("save");
        await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").submitLeasingPayment,
            menuName: `Penagihan Leasing - ${tab.replace("_", " ")}`,
            setError: this.props.setError,
            args: request,
        });
        this.setState((prevValue) => ({...prevValue, loading: false}));

    };

    handleSubmit = async (type) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let {tab} = this.props;

        const request = this.constructDataRequest(type);

        let err = service.validate(request, this.state.notEquals, this.state.signedBy);

        if (err) {
            await this.setState((prevState) => ({
                ...prevState,
                errors: err,
            }));
        }

        let allEmpty = false;

        if (Array.isArray(err.dataCetakan)) {
            allEmpty = err.dataCetakan.every(item => Object.keys(item).length === 0);
        }

        if (allEmpty) {
            delete err.dataCetakan;
        }

        if (R.isEmpty(removeNullFields(err))) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").submitLeasingPayment,
                menuName: `Penagihan Leasing - ${tab.replace("_", " ")}`,
                setError: this.props.setError,
                args: request,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.props.onClickClose(null);
            }
        }
        this.setState((prevValue) => ({...prevValue, loading: false, cancelAlert: false}));
    };

    handleCancelAlert = () => {
        this.setState((prevValue) => ({...prevValue, cancelAlert: !prevValue.cancelAlert}));
    };

    callOptionApis = (cityId, provinceId, kecamatanId, kelurahanId) => {
        return [
            Api.create("NAGAMAS_MASTER_DATA").getCityById(cityId),
            Api.create("NAGAMAS_MASTER_DATA").getProvinceById(provinceId),
            Api.create("NAGAMAS_MASTER_DATA").getKecamatanById(kecamatanId),
            Api.create("NAGAMAS_MASTER_DATA").getKelurahanById(kelurahanId),
        ];
    };

    mapResponses = (responses, key) => {
        responses.forEach((response, idx) => {
            if (response.ok) {
                const data = response.data.data;
                if (idx === 0) {
                    this.setDDLValue(
                        key,
                        "cityOptions",
                        data && mapToObjectDDL(data.kabKotName, data.kabKotId)
                    );
                } else if (idx === 1) {
                    this.setDDLValue(
                        key,
                        "provinceOptions",
                        data && mapToObjectDDL(data.provinceName, data.id)
                    );
                } else if (idx === 2) {
                    this.setDDLValue(
                        key,
                        "kecamatanOptions",
                        data && mapToObjectDDL(data.kecamatanName, data.id)
                    );
                } else {
                    this.setDDLValue(
                        key,
                        "kelurahanOptions",
                        data && mapToObjectDDL(data.kelurahanname, data.id)
                    );
                }
            }
        });
    };

    handleChangeSignature = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            signedBy: value,
            data: {
                ...prevValue.data,
                dataCetakan: prevValue.data.dataCetakan.map((item) => {
                    return {
                        ...item,
                        signedBy: value,
                    }
                }),
            }
        }));
    };

    setDDLValue = (key, fieldKey, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [key]: {
                ...prevValue[key],
                [fieldKey]: value,
            },
        }));
    };

    handleChangeCetakanValue = (part, name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                dataCetakan: prevValue.data.dataCetakan.map((item, idx) => {
                    if (idx === part) {
                        return {
                            ...item,
                            [name]: value,
                        };
                    }
                    return item;
                }),
            },
        }));
    };

    handleUncheckBbm = (bbm) => {
        this.handleChangePenagihanValue(bbm, null);
    };


    handlePreviewPdfVisibility = (value) => {
        if (value === false) {
            this.setState((prev) => ({
                ...prev,
                dataPreviewPdf: URL.revokeObjectURL(prev?.dataPreviewPdf),
                printPreviewVisible: value,
            }));
        } else {
            this.setState((prev) => ({
                ...prev,
                printPreviewVisible: value,
            }));
        }
    }

    handlePrintKwitansi = (part, data) => {
        let prefix = "";
        switch (part) {
            case 0:
                prefix = "Kwitansi_DP_"
                break;
            case 1:
                prefix = "Kwitansi_Pelunasan_"
                break;
            case 2:
                prefix = "Kwitansi_Subsidi_"
                break;
            default:
                prefix = "Cover_Note_"
                break;
        }
        printPDF(data)
    }

    handlePreviewKwitansi = (data) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataPreviewPdf: URL.createObjectURL(data),
        }));
        this.handlePreviewPdfVisibility(true);
    }

    handlePdfKwitansi = async (part = 0, type = 'print') => {
        try {
            this.setState((prevValue) => ({...prevValue, loading: true}));
            
            const payload = {
                kodeCabang: this.props.kodeCabang,
                idFJ: this.state.data?.nomorFakturJual || "",
                receivedFrom: this.state.data.dataCetakan[part].recipient,
                nominalInWord: this.state.data.dataCetakan[part].spelledAmount,
                purpose: this.state.data.dataCetakan[part].receiptPurpose,
                nominal: this.state.data.dataCetakan[part].amount ? FormatCurrencyWithoutSymbol({number: this.state.data.dataCetakan[part].amount}) : "",
                withLegalization: part === 1,
                idUser: this.state.data.dataCetakan[part].signedBy?.value || this.state.data.dataCetakan[part].signedBy,
            };
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").getInvoicePenagihanLeasing,
                menuName: "Penagihan Leasing",
                setError: this.props.setError,
                args: payload
            })
            if (res.ok) {
                if (type === 'print') {
                    this.handlePrintKwitansi(part, res.data)
                } else {
                    this.handlePreviewKwitansi(res.data)
                }
                this.setState((prevValue) => ({...prevValue, loading: false}));
            }
        } catch (error) {
            this.setState((prevValue) => ({...prevValue, loading: false}));
            console.log(error)
        }
    }

    handlePrintCoverLetter = async (file) => {
        let request = {
            refNumber: this.state.data?.nomorFakturJual,
            type: ReportType.COVER_NOTE,
        }
        // todo un comment after deploy print count services
        // await fetchDataAsync({
        //     asyncFn: Api.create("NAGAMAS_REPORT_DTO").updatePrintCount,
        //     menuName: "Penagihan Leasing",
        //     setError: this.props.setError,
        //     args: request,
        // });
        this.setState((prevValue) => ({...prevValue, loading: false}));
        printPDF(file);
    }

    handlePreviewCoverLetter = (data) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataPreviewPdf: URL.createObjectURL(data),
        }));
        this.handlePreviewPdfVisibility(true);
    }

    fetchPrintCountCoverLetter = async () => {
        const request = {
            refNumber: this.state.data?.nomorFakturJual,
            type: ReportType.COVER_NOTE,
        }
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT_DTO").getPrintCount,
            menuName: "Penagihan Leasing",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            return res.data.data;
        } else {
            return 0;
        }
    };

    handlePdfCoverLetter = async (type = 'print') => {
        const {signedBy, data} = this.state;
        // todo un comment after deploy print count services
        // let printCount = await this.fetchPrintCountCoverLetter();
        let printCount = data?.printCount;
        const idUser = localStorage.getItem("userId");

        if (!signedBy) {
            this.setState({
                errors: {...this.state.errors, signedBy: "Field Wajib Diisi!"},
            });
            return;
        }

        this.setState({
            errors: {...this.state.errors, signedBy: ""},
            loading: true,
        });
        try {
            this.setState((prevValue) => ({...prevValue, loading: true}));
            const signAddress = this.state.rawSignByOptions.filter(item => item.userId === this.state.signedBy?.value)
            const payload = {
                signName: this.state.signedBy?.label,
                signPosition: "Pimpinan",
                signAddress: signAddress.length > 0 ? signAddress[0].address : '',
                consumentOwnerName: data?.dataPemilik?.namaPembeli || '',
                vehicleType: data?.dataUnit?.dataVariant?.typeDTO?.typeName,
                vehicleMerk: "Honda",
                type: data?.dataUnit?.dataVariant?.typeDTO?.typeName || '',
                color: data?.dataUnit?.dataWarna?.namaWarnaKomersil || '',
                year: data?.dataUnit?.yearManufactured,
                engineNumber: data?.dataUnit?.engineNumber,
                frameNumber: data?.dataUnit?.frameNumber,
                consumentBuyerName: data?.dataCustomer?.namaPembeli || '',
                consumentBuyerAddress: data?.dataCustomer?.alamat || '',
                consumentBuyerNo: data?.dataCustomer?.nomorHP || '',
                leasingCompanyName: data?.dataLeasing?.leasingName || '',
                cabangName: data?.dataCabang?.kabKotName,
                abbreviationLeasingCompanyName: data?.dataLeasing?.abbreviatedName,
                statementPlace: data?.dataCabang?.kabKotName,
                statementDate: moment().format("DD-MM-YYYY"),
                printCount,
                userId: this.state.signedBy?.value
            };
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").getLetterCoverPenagihanLeasing,
                menuName: "Penagihan Leasing",
                setError: this.props.setError,
                args: payload
            })
            if (res.ok) {
                if (type === 'print') {
                    this.handlePrintCoverLetter(res.data)
                    return
                } else {
                    this.handlePreviewCoverLetter(res.data);
                }
            }
            this.setState((prevValue) => ({...prevValue, loading: false}));
        } catch (error) {
            this.setState((prevValue) => ({...prevValue, loading: false}));
            console.log(error)
        }
    }

    render() {
        const showKoreksiButton = this.props.tab === leasingPaymentStatus.SUDAH_PENAGIHAN;
        const showSaveBtn = this.props.tab === leasingPaymentStatus.SUDAH_PENAGIHAN && this.state.activeTabIndex !== 3;
        const isTabPelunasan = this.props.tab === leasingPaymentStatus.PELUNASAN;
        const viewActivity = this.props.detail.activityType === ACTIVITY_TYPE.VIEW;
        const updateActivity = this.props.detail.activityType === ACTIVITY_TYPE.UPDATE;
        const cancelActivity = this.props.detail.activityType === ACTIVITY_TYPE.CANCEL;
        return (
            <>
                <SimpleModal
                    title="Detail Data Penagihan Leasing"
                    visible={!!this.props.detail.id}
                    onClickClose={() => this.props.onClickClose("", "")}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_no_faktur_jual"
                                        name="noFakturJual"
                                        label="No. Faktur Jual"
                                        readOnly
                                        value={this.state.data?.nomorFakturJual}
                                    />
                                    <SimpleInput
                                        id="input_text_tgl_faktur_jual"
                                        name="tglFakturJual"
                                        label="Tgl. Faktur Jual"
                                        readOnly
                                        value={this.state.data?.tanggalFakturJual}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_leasing"
                                        name="namaLeasing"
                                        label="Nama Leasing"
                                        readOnly
                                        value={this.state.data?.dataLeasing?.leasingName}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleDDL
                                        id="select_options_no_indent"
                                        name="noIndent"
                                        label="No. Indent"
                                        box="search"
                                        readOnly
                                        value={mapToObjectDDL(
                                            this.state.data?.nomorIndent,
                                            this.state.data?.nomorIndent
                                        )}
                                    />
                                    <SimpleDDL
                                        id="select_options_no_prospect"
                                        name="noProspect"
                                        label="No. Prospect"
                                        box="search"
                                        readOnly
                                        value={mapToObjectDDL(
                                            this.state.data?.nomorProspek,
                                            this.state.data?.nomorProspek
                                        )}
                                    />
                                </div>
                            </div>
                            <Tabs
                                selectedIndex={this.state.activeTabIndex}
                                onSelect={(index) => this.setState({ activeTabIndex: index })}
                            >
                                <TabList>
                                    <Tab>Data Pembeli</Tab>
                                    <Tab>Data Pemilik</Tab>
                                    <Tab>Data Unit</Tab>
                                    <Tab>Data Penagihan</Tab>
                                    <Tab>Cetakan</Tab>
                                </TabList>
                                <TabPanel>
                                    <DataCustomerOwnerTab
                                        type="pembeli"
                                        data={this.state.data?.dataCustomer}
                                        ddlValues={this.state.customer}
                                        activeTabIndex={this.state.activeTabIndex}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <DataCustomerOwnerTab
                                        type="pemilik"
                                        data={this.state.data?.dataPemilik}
                                        ddlValues={this.state.owner}
                                        activeTabIndex={this.state.activeTabIndex}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <DataUnitTab data={this.state.data?.dataUnit} activeTabIndex={this.state.activeTabIndex}/>
                                </TabPanel>
                                <TabPanel>
                                    <DataPenagihanTab
                                        dataCustomer={this.state.data?.dataCustomer}
                                        data={this.state.data?.dataPenagihan}
                                        onValueChange={this.handleChangePenagihanValue}
                                        tab={this.props.tab}
                                        errors={this.state.errors}
                                        mandatory={this.state.notEquals}
                                        isTabPelunasan={isTabPelunasan}
                                        isUpdateActivity={updateActivity}
                                        isViewActivity={viewActivity}
                                        isCancelActivity={cancelActivity}
                                        showKoreksiButton={showKoreksiButton}
                                        handleSave={this.handleSave}
                                        handleUncheckBbm={this.handleUncheckBbm}
                                        handleOpenBBM={this.handleOpenBBM}
                                        activeTabIndex={this.state.activeTabIndex}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <div style={{border: "1px solid gray", padding: "10px"}}>
                                        <h4>Surat Cover Note</h4>
                                        <div style={{paddingLeft: "10px"}}>
                                            <SimpleDDL
                                                id="select_options_ttd"
                                                box="search"
                                                name="signedBy"
                                                mandatory
                                                label="Yang Bertanda Tangan"
                                                value={this.state.signedBy}
                                                options={this.state.signByOptions}
                                                onChange={(value, {name}) => this.handleChangeSignature(value)}
                                                errorMessage={this.state.errors?.signedBy}
                                            />
                                            <div style={{textAlign: "right"}}>
                                                <SimpleButton
                                                    onClick={() => this.handlePdfCoverLetter('preview')}>Preview</SimpleButton>
                                                {!isTabPelunasan && (<SimpleButton
                                                    onClick={() => this.handlePdfCoverLetter('print')}>Cetak</SimpleButton>)}
                                            </div>
                                        </div>
                                        <div className="spacer"/>
                                        <CetakanInput
                                            title="Kwitansi DP"
                                            part={0}
                                            state={this.state.data.dataCetakan}
                                            changeValue={this.handleChangeCetakanValue}
                                            errors={this.state.errors?.dataCetakan}
                                            isTabPelunasan={isTabPelunasan}
                                            handlePrint={(val) => this.handlePdfKwitansi(val, 'print')}
                                            handlePreview={(val) => this.handlePdfKwitansi(val, 'preview')}
                                        />
                                        <div className="spacer"/>
                                        <CetakanInput
                                            title="Kwitansi Pelunasan"
                                            part={1}
                                            state={this.state.data.dataCetakan}
                                            changeValue={this.handleChangeCetakanValue}
                                            errors={this.state.errors?.dataCetakan}
                                            isTabPelunasan={isTabPelunasan}
                                            handlePrint={(val) => this.handlePdfKwitansi(val, 'print')}
                                            handlePreview={(val) => this.handlePdfKwitansi(val, 'preview')}
                                        />
                                        <div className="spacer"/>
                                        <CetakanInput
                                            title="Kwitansi Subsidi"
                                            part={2}
                                            state={this.state.data.dataCetakan}
                                            changeValue={this.handleChangeCetakanValue}
                                            errors={this.state.errors?.dataCetakan}
                                            isTabPelunasan={isTabPelunasan}
                                            handlePrint={(val) => this.handlePdfKwitansi(val, 'print')}
                                            handlePreview={(val) => this.handlePdfKwitansi(val, 'preview')}
                                        />
                                        {updateActivity && (
                                            <>
                                                <div className="spacer"/>
                                                <div style={{textAlign: "right"}}>
                                                    <SimpleButton onClick={this.handleSave} secondary
                                                                  className="margin-top-15px">
                                                        Simpan
                                                    </SimpleButton>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </TabPanel>
                            </Tabs>
                            {(updateActivity || cancelActivity) && (
                                <div style={{textAlign: "right", marginTop: "15px"}}>
                                    {cancelActivity ? (
                                        <SimpleButton
                                            onClick={this.handleCancelAlert}
                                            secondary
                                        >
                                            Batal
                                        </SimpleButton>
                                    ) : (
                                        <>
                                            <SimpleButton onClick={() => this.handleSubmit("process")}>
                                                Proses
                                            </SimpleButton>
                                            {showSaveBtn &&
                                                <SimpleButton onClick={this.handleSave}>Simpan</SimpleButton>}
                                        </>
                                    )}
                                </div>
                            )}
                        </ModalContainer>
                    }
                />
                {this.state.openBBM && (
                    <ListBbm
                        {...this.props}
                        jpTac={this.state.jpTac}
                        data={this.state.data?.dataPenagihan}
                        visible={this.state.openBBM}
                        onClickClose={this.handleOpenBBM}
                        handleSubmit={this.handleSubmitBBM}
                    />
                )}
                {this.state.cancelAlert && (
                    <SimpleAlert
                        visible={this.state.cancelAlert}
                        title="Information"
                        onClickClose={this.handleCancelAlert}
                        content="Pembatalan Penagihan Leasing akan dilakukan. Apakah anda yakin?"
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleCancelAlert}>Batal</SimpleButton>
                                <SimpleButton onClick={() => this.handleSubmit("cancel")}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                <DetailPenagihanLeasingPrintPreview
                    {...this.props}
                    title="Preview Report Penagihan Leasing"
                    data={this.state.dataPreviewPdf}
                    visible={this.state.printPreviewVisible}
                    onClose={this.handlePreviewPdfVisibility}
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default Detail;

function CetakanInput({title, part, state, changeValue, errors, isTabPelunasan, handlePrint, handlePreview}) {
    return (
        <div style={{paddingLeft: "10px"}}>
            <h4>{title}</h4>
            <SimpleInput
                id={`input_text_telah_terima_${part}`}
                name="recipient"
                label="Telah Terima Dari"
                mandatory
                value={state[part]?.recipient}
                onChange={({target}) => changeValue(part, target.name, target.value)}
                errorMessage={Array.isArray(errors) ? errors?.[part].recipient : errors}
            />
            <SimpleInput
                id={`input_text_uang_sebanyak_${part}`}
                name="spelledAmount"
                label="Uang Sebanyak"
                readOnly
                value={state[part]?.spelledAmount}
                onChange={({target}) => changeValue(part, target.name, target.value)}
            />
            <SimpleTextArea
                id={`input_text_guna_membayar_${part}`}
                name="receiptPurpose"
                label="Guna Membayar"
                mandatory
                value={state[part]?.receiptPurpose}
                onChange={({target}) => changeValue(part, target.name, target.value)}
                errorMessage={Array.isArray(errors) ? errors?.[part].receiptPurpose : errors}
            />
            <div className="width width-250px">
                <SimpleDate
                    id={`select_date_${part}`}
                    name="receiptDate"
                    mandatory
                    date={state[part]?.receiptDate}
                    onChange={(value) => changeValue(part, "receiptDate", M(value).format("DD-MM-YYYY"))}
                    errorMessage={Array.isArray(errors) ? errors?.[part].receiptDate : errors}
                />
            </div>
            <div style={{textAlign: "right"}}>
                <SimpleButton onClick={() => handlePreview(part)}>Preview</SimpleButton>
                {!isTabPelunasan && <SimpleButton onClick={() => handlePrint(part)}>Cetak</SimpleButton>}
            </div>
        </div>
    );
}
